<template>
  <div class="content" v-if="!loading && vouchers">
    <div class="lineBox" style="padding-top:10px;border:0px;">
      <span class="h3" style="float:let;margin-top:5px;">Cadastro de Voucher</span>
      <button style="float:right;" @click="openNewVoucher()">Novo Voucher</button><br/><br/>

    </div>

    <div class="line">
      <div style="padding:10px; ">
        <table border="1" cellpadding="5px" style="min-width:700px; border-collapse:collapse; border:1px solid #706C7A;width:100%">
          <thead>
            <tr>
              <td>Nome</td>
              <td>Tipo Desconto</td>
              <td>Valor Desconto</td>
              <td>Data Expiração</td>
              <td>Código</td>
              <td>Usado Por</td>
              <td style="text-align:right;">Data Criação</td>
              <td style="width:50px;text-align:center;">Ações</td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(voucher, idx) in vouchers" v-bind:key="idx">
              <td>{{voucher.name}}</td>
              <td>{{voucher.discount_type}}</td>
              <td>{{voucher.discount_value}}</td>
              <td>{{formatDate(voucher.expire_at)}}</td>
              <td>{{voucher.code}}</td>
              <td>{{voucher.used_by}}</td>
              <td style="text-align:right;">{{formatDate(voucher.created_at)}}</td>
              <td style="text-align:center;">
                <a @click="removeVoucher(voucher)">
                  <font-awesome-icon style="font-size:18px;color:#bb3f5c;margin:5px;" :icon="['fal', 'trash-alt']"/>
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <OpaModal v-if="tempVoucher" width="900" height="490" v-model="modalVoucher" header="Voucher">
      <div style="height:350px;overflow:auto;width:100%">
        <b-container >
          <b-row style="margin-top:30px;">
            <b-col cols="4">
              Nome:<br/>
              <input type="text" class="inputWire" style="border-color:#ffffff;margin-bottom:10px;width:100%;" v-model="tempVoucher.voucher.name" />
            </b-col>
            <b-col cols="4">
              Código: <span style="font-size:12px;">(apenas letras maiúsculas e números)</span><br/>
              <input type="text" v-if="!generateCode" class="inputWire" v-voucherChars style="border-color:#ffffff;margin-bottom:10px;width:100%;" v-model="tempVoucher.voucher.code" />
              <div>Gerar automáticamente <input v-on:click="toggleGenerate()" type="checkbox"   v-model.number="tempVoucher.voucher.allow_one_use_per_user" /></div>
            </b-col>
            <b-col cols="4">
              Tipo Desconto:<br/>
              <b-form-select v-model="tempVoucher.voucher.discount_type" class="mb-3">
                <!-- This slot appears above the options from 'options' prop -->
                <template slot="first">
                  <option :value="null" disabled>-- Selecione uma opção --</option>
                </template>
                <!-- These options will appear after the ones from 'options' prop -->
                <option value="PERCENTAGE">Percentual</option>
                <option value="ABSOLUTE">Absoluto</option>
                <option value="DELIVERY">Frete Grátis</option>
              </b-form-select>
            </b-col>
          </b-row>

          <b-row style="margin-top:30px;">
            <b-col cols="4" v-if="tempVoucher.voucher.discount_type !== 'DELIVERY'">
              Valor:<br>
              <input type="number" class="inputWire" style="border-color:#ffffff;width:100%;margin-bottom:20px;" v-model.number="tempVoucher.voucher.discount_value" />
            </b-col>
            <b-col cols="4">
              Data Expiração:<br/>
              <imask-input :mask="mask.mask" v-model="tempVoucher.voucher.expire_at"/>
            </b-col>
            <b-col cols="4" v-if="generateCode">
              <span >Quantidade:</span><br/>
              <input v-if="generateCode" type="number" class="inputWire" style="border-color:#ffffff;width:100%;margin-bottom:20px;" v-model.number="tempVoucher.quantity" />
            </b-col>
            <b-col cols="8">
              <br/>
               Permitir múltiplas utilizações (um resgate por conta): <input type="checkbox"  v-model.number="tempVoucher.voucher.allow_one_use_per_user" />
            </b-col>
          </b-row>
        </b-container>
      </div>
      <div class="modal_footer">
      <button style="width:80px;float:right;margin:20px;" @click="saveVoucher(); modalVoucher=false">Salvar</button>
      <button class="buttonWire" style="width:80px;float:right;margin:20px;" @click="cancelEditVoucher()">Cancelar</button>
      </div>
    </OpaModal>
  </div>
  <div v-else></div>
</template>

<script>
import OpaModal from '@/components/OpaModal.vue'
import { EventBus } from '@/utils/event-bus'
import VoucherConn from '@/connection/voucher'
import formater from '@/mixins/formater'
import {IMaskComponent} from 'vue-imask'

export default {
  name: 'Vouchers',
  data () {
    return {
      vouchers: null,
      generateCode: false,
      loading: true,
      tempVoucher: null,
      modalVoucher: false,
      mask: {
        mask: '00/00/0000',
        lazy: false
      }

    }
  },

  mixins: [formater ],

  components: {OpaModal, 'imask-input': IMaskComponent},

  created () {
    if (this.loading) {
      EventBus.$emit('showLoading', true)
    }
    this.resetTempVoucher()
    this.loadVouchers()

  },

  methods: {

    async loadVouchers() {
      let result = await VoucherConn.getVouchers()
      if (result.error) {
        this.vouchers = []
        EventBus.$emit('showAlert', 'error', result.msg)
      } else {
        result.sort((a, b) => a.expire_at - b.expire_at)
        this.vouchers = result
      }
      this.loading = false
      EventBus.$emit('showLoading', false)

    },

    toggleGenerate() {
      this.generateCode = !this.generateCode
      this.tempVoucher.voucher.code = null
    },

    resetTempVoucher() {
      this.tempVoucher = {
        voucher: {
          name: null,
          discount_type: null,
          discount_value: 0,
          expire_at: null,
          created_at: null,
          code: null,
          used_by: null,
          allow_one_use_per_user: false,
        },
        quantity: 1
      }
      this.generateCode = false
    },

    openModalVoucher(voucher) {
      this.tempVoucher = voucher
      this.modalVoucher = true
    },

    openNewVoucher() {
      this.resetTempVoucher()
      this.modalVoucher = true
    },

    cancelEditVoucher() {
      this.resetTempVoucher()
      this.modalVoucher = false
    },

    async saveVoucher() {
      EventBus.$emit('showLoading', true)
      let dtEx = new Date()
      dtEx.setDate(Number(this.tempVoucher.voucher.expire_at.substring(0, 2)))
      dtEx.setMonth(Number(this.tempVoucher.voucher.expire_at.substring(3, 5)) -1)
      dtEx.setFullYear(Number(this.tempVoucher.voucher.expire_at.substring(6)))
      this.tempVoucher.voucher.expire_at = dtEx.getTime()
      if (this.generateCode) {
        this.tempVoucher.voucher.code = null
      } else {
        this.tempVoucher.quantity = 1
      }
      let result = await VoucherConn.saveVoucher(this.tempVoucher)
      EventBus.$emit('showLoading', false)
      if (!result.error) {
        this.resetTempVoucher()
        this.modalVoucher = false
        this.loadVouchers()
      } else {
        EventBus.$emit('showAlert', 'error', result.msg)
      }
    },

    async removeVoucher(voucher) {
      if (confirm('Deseja realmente excluir o voucher?')) {
        EventBus.$emit('showLoading', true)
        let result = await VoucherConn.removeVoucher(voucher.id)
        EventBus.$emit('showLoading', false)
        if (!result.error) {
          this.resetTempVoucher()
          this.modalVoucher = false
          this.loadVouchers()
        } else {
          EventBus.$emit('showAlert', 'error', result.msg)
        }
      }
    }
  }
}
</script>

<style>
a {
  cursor:pointer;
}
</style>
